/**
 * Extend the Window interface to include the `aap` property.
 * @typedef {typeof globalThis & { aap?: (...args: any[]) => void }} CustomWindow
 */

export async function aapPixel() {
  const win = /** @type {CustomWindow} */ (window)
  if (typeof window !== 'undefined' && typeof win.aap === 'function') {
    win.aap({ pixelKey: '3757068737042819660', pg: 37200 })
  }
}
